<template>
	<!-- inline-flex align-text-bottom relative flex-col items-center group -->
	<!-- <div class="absolute bottom-full flex flex-col items-center hidden mb-1 group-hover:flex">
			<span class="relative z-10 p-2 text-xs text-gray-100 bg-gray-700 shadow-lg rounded-md w-max max-w-12">
                <slot>{{text}}</slot>
            </span>
			<div class="w-3 h-3 -mt-2 rotate-45 bg-gray-700 z-10"></div>
    </div>-->

	<popper
		class
		trigger="hover"
		:options="{
			placement: placement,
		}"
	>
		<div
			class="popper p-2 text-xs text-gray-100 bg-gray-700 shadow-lg rounded-md max-w-[15rem] z-6100"
		>
			<slot name="content">
				{{ text }}
			</slot>
		</div>

		<button
			class="flex items-center"
			v-on:click.stop=""
			v-on:click.prevent=""
			slot="reference"
		>
			<slot v-if="hasLabel" name="label"></slot>
			<ui-icon
				v-else
				class="inline-block"
				:class="iconClass"
				name="help-circle"
				:stroke-width="iconStrokeWidth"
			/>
		</button>
	</popper>
</template>

<script>
import Popper from "vue-popperjs";
// import 'vue-popperjs/dist/vue-popper.css';

export default {
	components: {
		popper: Popper,
	},
	props: {
		text: {
			type: String,
			required: false,
		},
		iconClass: {
			type: String,
			default: "w-5 h-5",
		},
		iconStrokeWidth: {
			type: Number,
			default: 2,
		},
		placement: {
			type: String,
			default: "top",
		},
	},
	computed: {
		hasLabel() {
			return !!this.$slots.label;
		},
	},
};
</script>

<style>
.popper {
	width: auto;
	/* background-color: #fafafa;
    color: #212121; */
	text-align: center;
	padding: 0.25rem;
	display: inline-block;
	/* border-radius: 3px; */
	position: absolute;
	font-weight: normal;
	/* border: 1px #ebebeb solid; */
	z-index: 200000;
	/* -moz-box-shadow: rgb(58, 58, 58) 0 0 6px 0;
    -webkit-box-shadow: rgb(58, 58, 58) 0 0 6px 0;
    box-shadow: rgb(58, 58, 58) 0 0 6px 0; */
}
.popper .popper__arrow {
	width: 0;
	height: 0;
	border-style: solid;
	position: absolute;
	margin: 5px;
}
.popper[x-placement^="top"] {
	margin-bottom: 5px;
}
.popper[x-placement^="top"] .popper__arrow {
	border-width: 5px 5px 0 5px;
	border-color: #454545 transparent transparent transparent;
	bottom: -5px;
	left: calc(50% - 5px);
	margin-top: 0;
	margin-bottom: 0;
}
.popper[x-placement^="bottom"] {
	margin-top: 5px;
}
.popper[x-placement^="bottom"] .popper__arrow {
	border-width: 0 5px 5px 5px;
	border-color: transparent transparent #454545 transparent;
	top: -5px;
	left: calc(50% - 5px);
	margin-top: 0;
	margin-bottom: 0;
}
.popper[x-placement^="right"] {
	margin-left: 5px;
}
.popper[x-placement^="right"] .popper__arrow {
	border-width: 5px 5px 5px 0;
	border-color: transparent #454545 transparent transparent;
	left: -5px;
	top: calc(50% - 5px);
	margin-left: 0;
	margin-right: 0;
}
.popper[x-placement^="left"] {
	margin-right: 5px;
}
.popper[x-placement^="left"] .popper__arrow {
	border-width: 5px 0 5px 5px;
	border-color: transparent transparent transparent #454545;
	right: -5px;
	top: calc(50% - 5px);
	margin-left: 0;
	margin-right: 0;
}
</style>
